// extracted by mini-css-extract-plugin
export default {"bricks":"styles_bricks__J3+27","bold":"styles_bold__rQjOS","important":"styles_important__pIEyu","maintenance":"styles_maintenance__KVM5K"};